// Hardcoded AI-tool selections streamed to the customizer in discovery mode.
//
// Mirrors discoveryPrintMethods.ts / discoveryPricingRules.ts: selecting an AI Creative Tool in the
// discovery panel streams a small marker that the customizer reads to enable (and auto-open) that tool's
// sandbox experience. For image generation the customizer either runs the real feature (if the account has
// it) or a fully hardcoded sandbox flow (if it doesn't) — see the customizer's useDiscoveryImageGeneration.
//
// Add entries keyed by the DiscoveryModePanel item id. Design generation behaves like image generation:
// the customizer runs the real conversational editor if the account owns Design-with-AI, otherwise a fully
// hardcoded sandbox (fixed prompt + faked recolour) — see the customizer's useDiscoveryDesignGeneration.
// Product staging and virtual try-on follow the same split: the real AI Lifestyle Scenes / Try-On dialog if
// the product owns it, otherwise a hardcoded sandbox (fixed prompt + bundled placeholder images) — both share
// the customizer's useDiscoveryAiStaging controller (parameterised by tool).
export const DISCOVERY_AI_PAYLOADS: Record<string, object> = {
	'ai-image-generation': { tool: 'image-generation' },
	'ai-design-generation': { tool: 'design-generation' },
	'ai-product-staging': { tool: 'product-staging' },
	'ai-virtual-try-on': { tool: 'virtual-tryon' }
};
